import { z } from "zod";
import { CRITICALITIES, ASSET_STATUSES } from "@ghostwatch/shared-types";
import { assetTypeSchema, uuidSchema } from "./common";

export const criticalitySchema = z.enum(CRITICALITIES);
export const assetStatusSchema = z.enum(ASSET_STATUSES);

/** `POST /v1/assets` body. Mirrors `CreateAsset` in routes_core.rs. */
export const createAssetSchema = z.object({
  asset_type: assetTypeSchema,
  display_name: z.string().trim().min(1, "display name is required").max(200),
  identifier: z.string().trim().min(1, "identifier is required").max(512),
  criticality: criticalitySchema.optional(),
  environment: z.string().trim().max(100).optional().or(z.literal("")),
  scope_id: uuidSchema.optional().or(z.literal("")),
  tags: z.array(z.string().trim().min(1)).default([]),
});
export type CreateAssetInput = z.infer<typeof createAssetSchema>;

/** `PATCH /v1/assets/:id` body. Mirrors `UpdateAsset`. */
export const updateAssetSchema = z.object({
  display_name: z.string().trim().min(1).max(200).optional(),
  criticality: criticalitySchema.optional(),
  environment: z.string().trim().max(100).optional(),
  tags: z.array(z.string().trim().min(1)).optional(),
  status: assetStatusSchema.optional(),
});
export type UpdateAssetInput = z.infer<typeof updateAssetSchema>;
